import { render, staticRenderFns } from "./AdminPointRoute.vue?vue&type=template&id=910a738a&scoped=true"
import script from "./AdminPointRoute.vue?vue&type=script&lang=js"
export * from "./AdminPointRoute.vue?vue&type=script&lang=js"
import style0 from "./AdminPointRoute.vue?vue&type=style&index=0&id=910a738a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910a738a",
  null
  
)

export default component.exports